import { useContext, useMemo } from "react";
import {
  GenderButton,
  GenderButtons,
  Wrapper,
} from "./MobileToggleGender.styled";
import { getI18nRoute } from "src/utils/i18nRoutes";
import { AppCtx } from "src/contexts/app.context";
import { shopTypeTranslation } from "src/translations/shopTypeTranslation";
import { useLingui } from "@lingui/react";
import { useShopTypeContext } from "src/hooks/context/use-shop-type-context";
import { Locale } from "lib/Intl";

type MobileToggleGenderProps = {
  animationTime?: number;
  onClose?: boolean;
};

const filterOutGender: { [key in Locale]?: string[] } = {
  "en-gb": ["kids"],
};

function MobileToggleGender({
  animationTime,
  onClose,
}: MobileToggleGenderProps): JSX.Element {
  const { _ } = useLingui();
  const { locale } = useContext(AppCtx);
  const { currentShopType } = useShopTypeContext();

  const shopTypeIds = useMemo(() => {
    const shopTypes = ["women", "men", "kids"];

    return shopTypes.filter(
      (shopType) => !filterOutGender[locale]?.includes(shopType)
    );
  }, [locale]);

  return (
    <Wrapper
      p={3}
      bg="White"
      display={["flex", "flex", "flex", "none"]}
      duration={animationTime}
      shouldBeHidden={onClose}
    >
      <GenderButtons numberOfItems={shopTypeIds.length}>
        {shopTypeIds?.map((shopTypeIdValue, idx) => (
          <GenderButton
            key={`gender-button-${shopTypeIdValue || idx}`}
            href={getI18nRoute({
              route: `/${shopTypeIdValue || ""}`,
              locale,
            })}
            active={shopTypeIdValue === currentShopType}
            prefetch={false}
          >
            {_(shopTypeTranslation[shopTypeIdValue || ""] || "")}
          </GenderButton>
        ))}
      </GenderButtons>
    </Wrapper>
  );
}

export { MobileToggleGender };
